import { render } from "./UpdateMember.vue?vue&type=template&id=a9caefb4"
import script from "./UpdateMember.vue?vue&type=script&lang=js"
export * from "./UpdateMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__